module.exports = __webpack_public_path__ + "img/ANTENNA 3 GREEN.5c2f675.svg";